import { Alert } from '@mui/material';
import { useParams, Link } from 'react-router-dom';
import { useAppSelector } from 'src/store';

export function RecoveryLayout(props: { children: React.ReactNode }) {
  const { caseId } = useParams();
  const { banner } = useAppSelector((state) => state.caseItem);

  if (!banner) {
    return null;
  }
  if (!banner.referralAuthorized && !banner.locked) {
    return (
      <Alert severity="error">
        Donor not yet{' '}
        <Link to={`/case/${caseId}/referral/usage`}>authorized</Link>
      </Alert>
    );
  }

  return props.children;
}
